import { Checkbox, Stack, Typography } from '@/components';
import { useGlobal } from '@/contexts/GlobalContext';
import { getEditorData, MESSAGE_DATA_TYPE } from '@/utils/editor';
import { useEffect, useState } from 'react';
import styles from './DevelopmentView.module.css';

const DevelopmentView = (): JSX.Element => {
  const [settingsData, setSettingsData] = useState<any>(null);
  const {
    enableOptionSetTranslation,
    setEnableOptionSetTranslation,
    googleTranslateOnlyEmptyTranslations,
    setGoogleTranslateOnlyEmptyTranslations,
  } = useGlobal();

  useEffect(() => {
    getSettingsData();
  }, []);

  const getSettingsData = async () => {
    try {
      const settingsData = await getEditorData(MESSAGE_DATA_TYPE.OptionSet);
      setSettingsData(settingsData);
      console.log(settingsData);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.developmentView}>
      <Stack spacing={3} direction="column">
        <Stack spacing={2} direction="row" alignItems="center">
          <Checkbox
            checked={enableOptionSetTranslation}
            onChange={() => {
              setEnableOptionSetTranslation(!enableOptionSetTranslation);
            }}
          ></Checkbox>
          <Typography variant="labelMedium">
            Enable option set translation
          </Typography>
        </Stack>
        <Stack spacing={2} direction="row" alignItems="center">
          <Checkbox
            checked={googleTranslateOnlyEmptyTranslations}
            onChange={() => {
              setGoogleTranslateOnlyEmptyTranslations(
                !googleTranslateOnlyEmptyTranslations,
              );
            }}
          ></Checkbox>
          <Typography variant="labelMedium">
            Google translate only empty translations
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
};

export default DevelopmentView;
